module.exports = __webpack_public_path__ + "static/img/7_okinawa.83e67981.png";